import gql from 'graphql-tag'

export default gql`
    query GetUserData {
        getUserData {
            customerID
            company
            companyLegalForm
            salutation
            title
            firstName
            lastName
            email
            birthdate
            telephone
            mobile
            servicePin
            newsletterEmail
            twoFA
            customerData
            contractMetaData {
                activeContractIDs
                evn {
                    contractID
                    value
                }
                sendInvoice {
                    contractID
                    sendInvoicePostal
                    sendInvoiceKupo
                }
                activeContracts {
                    contractID
                    contractStart
                    contractEnd
                    possibleContractEnd
                    lastDateForCancellation
                }
            }
            connectionAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                houseNumberExt
                city
                zipCode
                country
            }
            billingAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                houseNumberExt
                city
                zipCode
                country
            }
            deliveryAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                houseNumberExt
                city
                zipCode
                country
            }
            accountHolderAddress {
                salutation
                title
                firstName
                lastName
                street
                houseNumber
                houseNumberExt
                city
                zipCode
                country
            }
            offers
            tips
            bankData {
                currentID
                accountHolder
                iban
                isTransfer
                bic
                creditorID
                Mandatsreferenz
            }
        }
    }
`
